import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Page from './views/Page.vue';
import Programs from './views/Programs.vue';
import GalleryRoot from './views/GalleryRoot.vue';
import Gallery from './views/Gallery.vue';
import AdminRoot from './views/AdminRoot.vue';
import Admin from './views/admin/Admin.vue';
import Pages from './views/admin/Pages.vue';
import PageEdit from './views/admin/PageEdit.vue';
import News from './views/admin/News.vue';
import NewsEdit from './views/admin/NewsEdit.vue';
import AdminGallery from './views/admin/Galleries.vue';
import AdminGalleryEdit from './views/admin/GalleryEdit.vue';
import AdminPrograms from './views/admin/Programs.vue';
import AdminProgramEdit from './views/admin/ProgramEdit.vue';
import AuthApiAgent from '@/services/auth-api-agent';

Vue.use(Router);

export default new Router(<any> {
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/page/:id',
      name: 'page',
      component: Page,
    },
    {
      path: '/programs',
      name: 'programs',
      component: Programs,
    },
    {
      path: '/gallery',
      name: 'gallery-root',
      component: GalleryRoot,
    },
    {
      path: '/gallery/:folder',
      name: 'gallery',
      component: Gallery,
    },
    {
      path: '/admin',
      component: AdminRoot,
      children: [
        {
          path: '',
          name: 'admin',
          component: Admin,
        },
        {
          path: 'pages',
          name: 'pages',
          component: Pages,
          beforeEnter: sessionCheck,
        },
        {
          path: 'pages/:id',
          name: 'page-edit',
          component: PageEdit,
          beforeEnter: sessionCheck,
        },
        {
          path: 'news',
          name: 'news',
          component: News,
          beforeEnter: sessionCheck,
        },
        {
          path: 'news/:id',
          name: 'news-edit',
          component: NewsEdit,
          beforeEnter: sessionCheck,
        },
        {
          path: 'programs',
          name: 'edit-programs',
          component: AdminPrograms,
          beforeEnter: sessionCheck,
        },
        {
          path: 'programs/:id',
          name: 'edit-programs-one',
          component: AdminProgramEdit,
          beforeEnter: sessionCheck,
        },
        // {
        //   path: 'files',
        //   name: 'files',
        //   component: GalleryRoot,
        //   beforeEnter: sessionCheck,
        // },
        {
          path: 'galleries',
          name: 'edit-gallery',
          component: AdminGallery,
          beforeEnter: sessionCheck,
        },
        {
          path: 'gallery/:id',
          name: 'edit-gallery-one',
          component: AdminGalleryEdit,
          beforeEnter: sessionCheck,
        }
      ],
    },
  ],
});

function sessionCheck(route: any, redirect: any, next: () => void) {
  if (AuthApiAgent.isAdmin) {
    next();
  } else {
    window.location.href = '/';
  }
}
